import { ApmBase } from '@elastic/apm-rum';
import { ApmVuePlugin, type ApmVuePluginOptions } from '@elastic/apm-rum-vue';
import type { FunctionPlugin } from 'vue';

import { setApm } from '@/plugins/apmAgent/lib/ApmUtils';

export type ApmAgentPluginOptions = ApmVuePluginOptions;

const ApmAgentPlugin: FunctionPlugin<ApmVuePluginOptions> = function (app, { router, config }) {
  // @see https://www.elastic.co/guide/en/apm/agent/rum-js/current/configuration.html
  app.use(ApmVuePlugin, { router, config });

  // Making the apm instance available for non-component files
  setApm(app.config.globalProperties.$apm as ApmBase);
};

export default ApmAgentPlugin;
